<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品学校-添加
    -->
  <el-dialog title="添加学校" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="所属学校" :label-width="formLabelWidth">
        <el-select v-model="form.parent_id">
          <el-option label="顶级学校" value="0"></el-option>
          <el-option :value="cat.card_category_id" :label="cat.name" :key="cat.card_category_id" v-for="cat in addform.catList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学校名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="学校图片" prop="path" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.path!=''" class="img">
            <img :src="form.path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="学校排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addCardCategory" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>

</template>

<script>
  import SupplyApi from '@/api/supply.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          parent_id: '0',
          name: '',
          sort: 100,
          path: ''
        },
        formRules: {
          name: [{
            required: true,
            message: '请输入学校名称',
            trigger: 'blur'
          }],
          path: [{
            required: true,
            message: '请上传学校图片',
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: '学校排序不能为空'
          }, {
            type: 'number',
            message: '学校排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_add', 'addform'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加名片学校*/
      addCardCategory() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SupplyApi.addCategory(params).then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },

    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/category/Add.vue